import { Checkbox, Group, InputWrapperProps } from "@mantine/core";
import { useFormHelperContext } from "../form";
import { InputWrapper } from "../inputWrapper";

interface CheckboxOption {
    label: string;
    name: string;
}
export interface FieldInputCheckboxMultiProps
    extends InputWrapperProps {
    error?: string;
    inputWrapper?: InputWrapperProps;
    options: CheckboxOption[];
    label: string;
    children?: React.ReactNode;
    readOnly?: boolean;
}

const HORIZONTAL_FORM_CLASSES_INPUT = {
    root: "flex-grow"
}
export const FieldInputCheckboxMulti: React.FC<FieldInputCheckboxMultiProps> = ({ options, label, inputWrapper, readOnly, ...rest }) => {
    const { register, formStore } = useFormHelperContext()

    if (!register) {
        throw new Error("Field.Text must be used within a FormHelper component");
    }

    return (
        <InputWrapper label={label} {...inputWrapper}  withAsterisk={rest.withAsterisk}>
            <div className="flex flex-grow">
                <Group>
                    {options.map((option, index) => {
                        return (
                            <Checkbox
                                data-testid={'field-checkbox-multi-' + option.name}
                                key={index}
                                label={option.label}
                                classNames={formStore.horizontalForm ? HORIZONTAL_FORM_CLASSES_INPUT : undefined}
                                {...register(option.name)}
                                readOnly={readOnly ?? formStore.readOnly}
                            />)
                    })}
                </Group>
            </div>
        </InputWrapper>
    )
}
